// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { telos as _telos } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the telos chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 40
 * Chain Name: Telos
 * Default Block Explorer: https://www.teloscan.io/
 * Default RPC URL: https://mainnet.telos.net/evm
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { telos } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: telos,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const telos = createCommon({
	..._telos,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
